export default function rankingSchoolsGrid() {

    const toggleBtnDiv = document.getElementById("toggleBtnDiv");
    const toggleBtnText = document.getElementById("toggleBtnText");
    const grid = document.querySelector(".top-20-ranking-schools .section-body.grid");

    if (!toggleBtnDiv || !toggleBtnText || !grid) return; // safety check


    toggleBtnDiv.addEventListener("click", (event) => {
        event.preventDefault();
        const items = Array.from(grid.querySelectorAll("a:nth-child(n+11)"));
        const isExpanded = grid.classList.contains("expanded");

        if (!isExpanded) {
            grid.classList.add("expanded");

            items.forEach((item, i) => {
                item.style.display = "flex";
                item.style.opacity = 0;
                item.style.transform = "translateY(-20px)";
                item.style.transition = `all 0.5s ease ${i * 0.1}s`;
            });

            void grid.offsetWidth;

            items.forEach(item => {
                item.style.opacity = 1;
                item.style.transform = "translateY(0)";
            });

            toggleBtnText.textContent = "View less";

        } else {
            items.forEach((item, i) => {
                item.style.transition = `all 0.5s ease ${i * 0.1}s`;
                item.style.opacity = 0;
                item.style.transform = "translateY(-20px)";

                item.addEventListener("transitionend", function handler() {
                    item.style.display = "none";
                    item.style.transition = "";
                    item.removeEventListener("transitionend", handler);
                });
            });

            grid.classList.remove("expanded");
            toggleBtnText.textContent = "View more";
        }
    });
}